<template>
    <p-search-input
        v-model="model"
        label="Dimension"
        :callback="callback"
        :get-one-callback="getOneCallback"
        :reset-func="resetFunc"
        :items="items"
        hide-details="auto"
        :action="action"
        v-bind="$props"
        v-on="$listeners"
        @tab="$emit('tab')">
    </p-search-input>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PSearchInput from '../common/PSearchInput';
import { searchDimensionByNameOrCode as callback, getDimensionById as getOneCallback } from './../../services/ledger/dimension';

export default {
    name: "PDimensionSearch",
    components: {
        PSearchInput
    },
    props: {
        backgroundColor: String,
        outlined: Boolean,
        disabled: Boolean,
        value: [String, Number],
        hideDetails: [Boolean, String]
    },
    computed: {
        ...mapState("accounting/dimension", {
            items: (state) => state.dimensionsLookup
        }),
        model: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val)
            }
        }
    },
    methods: {
        ...mapActions("accounting/dimension", {
            action: 'setDimensionsLookup',
            resetFunc: 'resetDimensionsLookup'
        }),
        callback,
        getOneCallback
    }
}
</script>